import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { EnhancedFormControl } from '../../models/rt-common';

@Directive({
  selector: '[sigvDetectDefaultValueDifference]',
})
export class DetectDefaultValueDifferenceDirective implements AfterViewInit {
  @Input() applyDifferenceDetect!: boolean;
  @Input()
  beforeInputValue!: EnhancedFormControl<any> | undefined;
  @Input()
  afterInputValue!: EnhancedFormControl<any> | undefined;

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    this.afterInputValue?.valueChanges.subscribe((res) => {
      if (
        this.isDiff(
          this.beforeInputValue?.getRawValue(),
          this.afterInputValue?.getRawValue()
        ) &&
        this.applyDifferenceDetect
      ) {
        (this.el.nativeElement as HTMLElement).classList.add('value-diff');
      } else {
        (this.el.nativeElement as HTMLElement).classList.remove('value-diff');
      }
    });
  }

  private isDiff(before: string, after: string): boolean {
    if (before !== null && after !== null && before !== after) {
      return true;
    }
    return false;
  }
}
